/**
 * 国家编码：ISO 3166-1 alpha-2。
 * 界面显示格式：编码（国家名称英文/国家名称中文）
 */
export interface CountryOption {
  code: string;
  nameEn: string;
  nameZh: string;
}

const nameZhMap: Record<string, string> = {
  AF: '阿富汗', AL: '阿尔巴尼亚', DZ: '阿尔及利亚', AS: '美属萨摩亚', AD: '安道尔', AO: '安哥拉',
  AI: '安圭拉', AG: '安提瓜和巴布达', AR: '阿根廷', AM: '亚美尼亚', AW: '阿鲁巴', AU: '澳大利亚',
  AT: '奥地利', AZ: '阿塞拜疆', BS: '巴哈马', BH: '巴林', BD: '孟加拉国', BB: '巴巴多斯',
  BY: '白俄罗斯', BE: '比利时', BZ: '伯利兹', BJ: '贝宁', BM: '百慕大', BT: '不丹',
  BO: '玻利维亚', BA: '波黑', BW: '博茨瓦纳', BR: '巴西', BN: '文莱', BG: '保加利亚',
  BF: '布基纳法索', BI: '布隆迪', KH: '柬埔寨', CM: '喀麦隆', CA: '加拿大', CV: '佛得角',
  KY: '开曼群岛', CF: '中非', TD: '乍得', CL: '智利', CN: '中国', CO: '哥伦比亚',
  KM: '科摩罗', CG: '刚果(布)', CD: '刚果(金)', CR: '哥斯达黎加', CI: '科特迪瓦',
  HR: '克罗地亚', CU: '古巴', CY: '塞浦路斯', CZ: '捷克', DK: '丹麦', DJ: '吉布提',
  DM: '多米尼克', DO: '多米尼加', EC: '厄瓜多尔', EG: '埃及', SV: '萨尔瓦多',
  GQ: '赤道几内亚', ER: '厄立特里亚', EE: '爱沙尼亚', ET: '埃塞俄比亚', FJ: '斐济',
  FI: '芬兰', FR: '法国', GA: '加蓬', GM: '冈比亚', GE: '格鲁吉亚', DE: '德国',
  GH: '加纳', GR: '希腊', GD: '格林纳达', GT: '危地马拉', GN: '几内亚', GW: '几内亚比绍',
  GY: '圭亚那', HT: '海地', HN: '洪都拉斯', HK: '中国香港', HU: '匈牙利', IS: '冰岛',
  IN: '印度', ID: '印度尼西亚', IR: '伊朗', IQ: '伊拉克', IE: '爱尔兰', IL: '以色列',
  IT: '意大利', JM: '牙买加', JP: '日本', JO: '约旦', KZ: '哈萨克斯坦', KE: '肯尼亚',
  KW: '科威特', KG: '吉尔吉斯斯坦', LA: '老挝', LV: '拉脱维亚', LB: '黎巴嫩', LS: '莱索托',
  LR: '利比里亚', LY: '利比亚', LI: '列支敦士登', LT: '立陶宛', LU: '卢森堡', MO: '中国澳门',
  MG: '马达加斯加', MW: '马拉维', MY: '马来西亚', MV: '马尔代夫', ML: '马里', MT: '马耳他',
  MR: '毛里塔尼亚', MU: '毛里求斯', MX: '墨西哥', MD: '摩尔多瓦', MC: '摩纳哥', MN: '蒙古',
  ME: '黑山', MA: '摩洛哥', MZ: '莫桑比克', MM: '缅甸', NA: '纳米比亚', NP: '尼泊尔',
  NL: '荷兰', NZ: '新西兰', NI: '尼加拉瓜', NE: '尼日尔', NG: '尼日利亚', MK: '北马其顿',
  NO: '挪威', OM: '阿曼', PK: '巴基斯坦', PA: '巴拿马', PG: '巴布亚新几内亚', PY: '巴拉圭',
  PE: '秘鲁', PH: '菲律宾', PL: '波兰', PT: '葡萄牙', QA: '卡塔尔', RO: '罗马尼亚',
  RU: '俄罗斯', RW: '卢旺达', KN: '圣基茨和尼维斯', LC: '圣卢西亚', VC: '圣文森特和格林纳丁斯',
  WS: '萨摩亚', SM: '圣马力诺', SA: '沙特阿拉伯', SN: '塞内加尔', RS: '塞尔维亚',
  SC: '塞舌尔', SL: '塞拉利昂', SG: '新加坡', SK: '斯洛伐克', SI: '斯洛文尼亚', SO: '索马里',
  ZA: '南非', KR: '韩国', SS: '南苏丹', ES: '西班牙', LK: '斯里兰卡', SD: '苏丹',
  SR: '苏里南', SE: '瑞典', CH: '瑞士', SY: '叙利亚', TW: '中国台湾', TJ: '塔吉克斯坦',
  TZ: '坦桑尼亚', TH: '泰国', TL: '东帝汶', TG: '多哥', TO: '汤加', TT: '特立尼达和多巴哥',
  TN: '突尼斯', TR: '土耳其', TM: '土库曼斯坦', UG: '乌干达', UA: '乌克兰', AE: '阿联酋',
  GB: '英国', US: '美国', UY: '乌拉圭', UZ: '乌兹别克斯坦', VU: '瓦努阿图', VE: '委内瑞拉',
  VN: '越南', YE: '也门', ZM: '赞比亚', ZW: '津巴布韦',
};

/** ISO 3166-1 alpha-2 国家列表（英文名来自 ISO，中文名见 nameZhMap） */
export const COUNTRY_LIST: CountryOption[] = [
  { code: 'AF', nameEn: 'Afghanistan', nameZh: nameZhMap['AF'] ?? 'Afghanistan' },
  { code: 'AL', nameEn: 'Albania', nameZh: nameZhMap['AL'] ?? 'Albania' },
  { code: 'DZ', nameEn: 'Algeria', nameZh: nameZhMap['DZ'] ?? 'Algeria' },
  { code: 'AR', nameEn: 'Argentina', nameZh: nameZhMap['AR'] ?? 'Argentina' },
  { code: 'AU', nameEn: 'Australia', nameZh: nameZhMap['AU'] ?? 'Australia' },
  { code: 'AT', nameEn: 'Austria', nameZh: nameZhMap['AT'] ?? 'Austria' },
  { code: 'BH', nameEn: 'Bahrain', nameZh: nameZhMap['BH'] ?? 'Bahrain' },
  { code: 'BD', nameEn: 'Bangladesh', nameZh: nameZhMap['BD'] ?? 'Bangladesh' },
  { code: 'BE', nameEn: 'Belgium', nameZh: nameZhMap['BE'] ?? 'Belgium' },
  { code: 'BR', nameEn: 'Brazil', nameZh: nameZhMap['BR'] ?? 'Brazil' },
  { code: 'BN', nameEn: 'Brunei Darussalam', nameZh: nameZhMap['BN'] ?? 'Brunei Darussalam' },
  { code: 'CA', nameEn: 'Canada', nameZh: nameZhMap['CA'] ?? 'Canada' },
  { code: 'CL', nameEn: 'Chile', nameZh: nameZhMap['CL'] ?? 'Chile' },
  { code: 'CN', nameEn: 'China', nameZh: nameZhMap['CN'] ?? 'China' },
  { code: 'CO', nameEn: 'Colombia', nameZh: nameZhMap['CO'] ?? 'Colombia' },
  { code: 'CR', nameEn: 'Costa Rica', nameZh: nameZhMap['CR'] ?? 'Costa Rica' },
  { code: 'HR', nameEn: 'Croatia', nameZh: nameZhMap['HR'] ?? 'Croatia' },
  { code: 'CZ', nameEn: 'Czechia', nameZh: nameZhMap['CZ'] ?? 'Czechia' },
  { code: 'DK', nameEn: 'Denmark', nameZh: nameZhMap['DK'] ?? 'Denmark' },
  { code: 'EG', nameEn: 'Egypt', nameZh: nameZhMap['EG'] ?? 'Egypt' },
  { code: 'EE', nameEn: 'Estonia', nameZh: nameZhMap['EE'] ?? 'Estonia' },
  { code: 'FI', nameEn: 'Finland', nameZh: nameZhMap['FI'] ?? 'Finland' },
  { code: 'FR', nameEn: 'France', nameZh: nameZhMap['FR'] ?? 'France' },
  { code: 'DE', nameEn: 'Germany', nameZh: nameZhMap['DE'] ?? 'Germany' },
  { code: 'GH', nameEn: 'Ghana', nameZh: nameZhMap['GH'] ?? 'Ghana' },
  { code: 'GR', nameEn: 'Greece', nameZh: nameZhMap['GR'] ?? 'Greece' },
  { code: 'HK', nameEn: 'Hong Kong', nameZh: nameZhMap['HK'] ?? 'Hong Kong' },
  { code: 'HU', nameEn: 'Hungary', nameZh: nameZhMap['HU'] ?? 'Hungary' },
  { code: 'IN', nameEn: 'India', nameZh: nameZhMap['IN'] ?? 'India' },
  { code: 'ID', nameEn: 'Indonesia', nameZh: nameZhMap['ID'] ?? 'Indonesia' },
  { code: 'IR', nameEn: 'Iran, Islamic Republic of', nameZh: nameZhMap['IR'] ?? 'Iran' },
  { code: 'IE', nameEn: 'Ireland', nameZh: nameZhMap['IE'] ?? 'Ireland' },
  { code: 'IL', nameEn: 'Israel', nameZh: nameZhMap['IL'] ?? 'Israel' },
  { code: 'IT', nameEn: 'Italy', nameZh: nameZhMap['IT'] ?? 'Italy' },
  { code: 'JP', nameEn: 'Japan', nameZh: nameZhMap['JP'] ?? 'Japan' },
  { code: 'JO', nameEn: 'Jordan', nameZh: nameZhMap['JO'] ?? 'Jordan' },
  { code: 'KZ', nameEn: 'Kazakhstan', nameZh: nameZhMap['KZ'] ?? 'Kazakhstan' },
  { code: 'KE', nameEn: 'Kenya', nameZh: nameZhMap['KE'] ?? 'Kenya' },
  { code: 'KW', nameEn: 'Kuwait', nameZh: nameZhMap['KW'] ?? 'Kuwait' },
  { code: 'LV', nameEn: 'Latvia', nameZh: nameZhMap['LV'] ?? 'Latvia' },
  { code: 'LB', nameEn: 'Lebanon', nameZh: nameZhMap['LB'] ?? 'Lebanon' },
  { code: 'MY', nameEn: 'Malaysia', nameZh: nameZhMap['MY'] ?? 'Malaysia' },
  { code: 'MT', nameEn: 'Malta', nameZh: nameZhMap['MT'] ?? 'Malta' },
  { code: 'MX', nameEn: 'Mexico', nameZh: nameZhMap['MX'] ?? 'Mexico' },
  { code: 'MO', nameEn: 'Macao', nameZh: nameZhMap['MO'] ?? 'Macao' },
  { code: 'NL', nameEn: 'Netherlands, Kingdom of the', nameZh: nameZhMap['NL'] ?? 'Netherlands' },
  { code: 'NZ', nameEn: 'New Zealand', nameZh: nameZhMap['NZ'] ?? 'New Zealand' },
  { code: 'NG', nameEn: 'Nigeria', nameZh: nameZhMap['NG'] ?? 'Nigeria' },
  { code: 'NO', nameEn: 'Norway', nameZh: nameZhMap['NO'] ?? 'Norway' },
  { code: 'OM', nameEn: 'Oman', nameZh: nameZhMap['OM'] ?? 'Oman' },
  { code: 'PK', nameEn: 'Pakistan', nameZh: nameZhMap['PK'] ?? 'Pakistan' },
  { code: 'PA', nameEn: 'Panama', nameZh: nameZhMap['PA'] ?? 'Panama' },
  { code: 'PE', nameEn: 'Peru', nameZh: nameZhMap['PE'] ?? 'Peru' },
  { code: 'PH', nameEn: 'Philippines', nameZh: nameZhMap['PH'] ?? 'Philippines' },
  { code: 'PL', nameEn: 'Poland', nameZh: nameZhMap['PL'] ?? 'Poland' },
  { code: 'PT', nameEn: 'Portugal', nameZh: nameZhMap['PT'] ?? 'Portugal' },
  { code: 'QA', nameEn: 'Qatar', nameZh: nameZhMap['QA'] ?? 'Qatar' },
  { code: 'RO', nameEn: 'Romania', nameZh: nameZhMap['RO'] ?? 'Romania' },
  { code: 'RU', nameEn: 'Russian Federation', nameZh: nameZhMap['RU'] ?? 'Russian Federation' },
  { code: 'SA', nameEn: 'Saudi Arabia', nameZh: nameZhMap['SA'] ?? 'Saudi Arabia' },
  { code: 'SG', nameEn: 'Singapore', nameZh: nameZhMap['SG'] ?? 'Singapore' },
  { code: 'SK', nameEn: 'Slovakia', nameZh: nameZhMap['SK'] ?? 'Slovakia' },
  { code: 'SI', nameEn: 'Slovenia', nameZh: nameZhMap['SI'] ?? 'Slovenia' },
  { code: 'ZA', nameEn: 'South Africa', nameZh: nameZhMap['ZA'] ?? 'South Africa' },
  { code: 'KR', nameEn: 'Korea, Republic of', nameZh: nameZhMap['KR'] ?? 'Korea, Republic of' },
  { code: 'ES', nameEn: 'Spain', nameZh: nameZhMap['ES'] ?? 'Spain' },
  { code: 'LK', nameEn: 'Sri Lanka', nameZh: nameZhMap['LK'] ?? 'Sri Lanka' },
  { code: 'SE', nameEn: 'Sweden', nameZh: nameZhMap['SE'] ?? 'Sweden' },
  { code: 'CH', nameEn: 'Switzerland', nameZh: nameZhMap['CH'] ?? 'Switzerland' },
  { code: 'TW', nameEn: 'Taiwan, Province of China', nameZh: nameZhMap['TW'] ?? 'Taiwan' },
  { code: 'TH', nameEn: 'Thailand', nameZh: nameZhMap['TH'] ?? 'Thailand' },
  { code: 'TR', nameEn: 'Türkiye', nameZh: nameZhMap['TR'] ?? 'Türkiye' },
  { code: 'UG', nameEn: 'Uganda', nameZh: nameZhMap['UG'] ?? 'Uganda' },
  { code: 'UA', nameEn: 'Ukraine', nameZh: nameZhMap['UA'] ?? 'Ukraine' },
  { code: 'AE', nameEn: 'United Arab Emirates', nameZh: nameZhMap['AE'] ?? 'United Arab Emirates' },
  { code: 'GB', nameEn: 'United Kingdom of Great Britain and Northern Ireland', nameZh: nameZhMap['GB'] ?? 'United Kingdom' },
  { code: 'US', nameEn: 'United States of America', nameZh: nameZhMap['US'] ?? 'United States of America' },
  { code: 'UY', nameEn: 'Uruguay', nameZh: nameZhMap['UY'] ?? 'Uruguay' },
  { code: 'UZ', nameEn: 'Uzbekistan', nameZh: nameZhMap['UZ'] ?? 'Uzbekistan' },
  { code: 'VE', nameEn: 'Venezuela, Bolivarian Republic of', nameZh: nameZhMap['VE'] ?? 'Venezuela' },
  { code: 'VN', nameEn: 'Viet Nam', nameZh: nameZhMap['VN'] ?? 'Viet Nam' },
  { code: 'YE', nameEn: 'Yemen', nameZh: nameZhMap['YE'] ?? 'Yemen' },
  { code: 'ZM', nameEn: 'Zambia', nameZh: nameZhMap['ZM'] ?? 'Zambia' },
  { code: 'ZW', nameEn: 'Zimbabwe', nameZh: nameZhMap['ZW'] ?? 'Zimbabwe' },
].sort((a, b) => a.nameEn.localeCompare(b.nameEn));

/** 下拉显示：编码（英文/中文） */
export function formatCountryLabel(opt: CountryOption): string {
  return `${opt.code} (${opt.nameEn}/${opt.nameZh})`;
}

/** Select filterSort：编码完全匹配优先，其次编码前缀匹配 */
export function countryFilterSort(
  a: { label?: unknown; value?: unknown },
  b: { label?: unknown; value?: unknown },
  info: { searchValue: string }
): number {
  const q = (info.searchValue || '').trim().toUpperCase();
  const rank = (o: { value?: unknown }) => {
    const code = String(o.value ?? '').toUpperCase();
    if (!q) return 2;
    if (code === q) return 0;
    if (code.startsWith(q)) return 1;
    return 2;
  };
  return rank(a) - rank(b) || String(a.label ?? '').localeCompare(String(b.label ?? ''));
}

export function getCountryByCode(code: string): CountryOption | undefined {
  return COUNTRY_LIST.find((c) => c.code === code);
}
